export const toLowerDashCase = (str?: string) =>
  str?.replace(/\s+/g, "-").toLowerCase();
